import React, { useState, useEffect } from "react";
import PswdShown from "@material-ui/icons/Visibility";
import PswdHidden from "@material-ui/icons/VisibilityOff";
import "./style.css";

function MyAccount() {
  useEffect(() => {
    document.title = "My Account | Ski Design";
  }, []);
  const [isPasswordShown, setIsPasswordShown] = useState(false),
    changePswdVisibility = (action) => {
      action === "hide" ? setIsPasswordShown(false) : setIsPasswordShown(true);
    };
  return (
    <div className="form-container">
      <div className="upper-rotated-container"></div>
      <div className="form-cont position-relative">
        <h2 className="form-header">My Account</h2>
        <form className="d-flex flex-column align-items-center justify-content-center mb-3">
          <input
            type="text"
            required
            placeholder="Full Name"
            className="fullname my-3"
          />
          <input
            type="email my-3"
            required
            placeholder="Email Address"
            className="email"
          />
          <div style={{ position: "relative" }}>
            <input
              type={isPasswordShown ? "text" : "password"}
              required
              placeholder="Password"
              className="password my-3"
              autoComplete="off"
            />
            {isPasswordShown ? (
              <PswdShown
                titleAccess="Hide password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("hide")}
              />
            ) : (
              <PswdHidden
                titleAccess="Show password"
                className="pswdShowHide"
                onClick={() => changePswdVisibility("show")}
              />
            )}
          </div>
          <button className="submit-btn">Log Out</button>
        </form>
      </div>
      <div className="lower-rotated-container"></div>
    </div>
  );
}

export default MyAccount;
